import { v4 as uuidv4 } from 'uuid';

export const MIN_USERNAME_LENGTH = 3;
export const MAX_USERNAME_LENGTH = 20;

const FALLBACK_SUFFIX_LENGTH = 8;
const FALLBACK_SEPARATOR = '-';

const VALID_USERNAME_REGEX = /^[a-z0-9-]+$/;

export function formatUsername(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '')
    .slice(0, MAX_USERNAME_LENGTH);
}

export function isValidUsername(username: string): boolean {
  return (
    VALID_USERNAME_REGEX.test(username) &&
    username.length >= MIN_USERNAME_LENGTH &&
    username.length <= MAX_USERNAME_LENGTH
  );
}

export function buildFallbackUsername(prefix: string): string {
  const suffix = uuidv4().replace(/-/g, '').slice(0, FALLBACK_SUFFIX_LENGTH);
  const maxPrefixLength = MAX_USERNAME_LENGTH - suffix.length - FALLBACK_SEPARATOR.length;
  return `${prefix.slice(0, maxPrefixLength)}${FALLBACK_SEPARATOR}${suffix}`;
}
